/*=========================================================================================
  File Name: moduleExpenseSetting.js
  Description: ExpenseSetting Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleExpenseSettingState.js';
import mutations from './moduleExpenseSettingMutation';
import actions from './moduleExpenseSettingAction';
import getters from './moduleExpenseSettingGetter';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
